import Vue from "vue";
import VueRouter from "vue-router";
// import store from "@/store";
import routes from "./routes.js";
import NProgress from 'nprogress';
import Cookies from 'js-cookie'
import { auth_check_invitation_code, auth_current_user } from '@/api/auth'
// import resourceLoader from '@/resource-loader.js'

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
});

router.beforeEach(async (to, from, next) => {

  // console.log("[router] route-guard (invitation)",
  //   from.path, JSON.stringify(from.query), ">>>",
  //   to.path, JSON.stringify(to.query));

  if ( to.matched.some(record => record.meta.requiresNoAuth) ) {
    /* We're currently on a route that does not require auth. This means there is not
       point in checking the invitation code now. */
    // if ( to.query.code ) {
    //   Cookies.set('invitationCode', to.query.code, { expires: 7 })
    // }
    next();
  }

  if ( to.query.referral ) {
    /* This is referral link */
    console.log("Got referral code", to.query.referral )
    Cookies.set('referralCode', to.query.referral, { expires: 31 })
    // TODO
  }

  if ( to.query.code ) {
    try {
      await auth_check_invitation_code( to.query || {} )

      router.app.$notify.success({
        title: 'Invitation accepted', // TODO bessere formulierung
        message: "Invitation accepted",
      });

      /* redirect to deeplink  */
      if ( to.query.redirect ) {
        next({ path: to.query.redirect, query: {} })
      } else {
        next({ path: '/today', query: {} })
      }
      return

    } catch ( error ) {

      if ( error.message === 'not-logged-in' ) {

        /* Store code in cookie, so we can try again after login / registration
           (Don't keep code in route query, otherwise we'll get a infity loop,
           because to.query.code will still be present when beforeEach is
           triggered the next time.) */
        Cookies.set('invitationCode', to.query.code, { expires: 7 })

        /* redirect to /register or /login (keep query) */
        next({
          path: "/register", // "/login"
          query: {
            redirect: to.query.redirect,
            email:    to.query.email
          }
        })
        return
      }

      if ( error.message === 'wrong-code' ) {
        /* Wrong invitation code, just redirect to the content - probably user clicked
           on invitation link again*/
        router.app.$notify.warning({
          title: 'Warning',
          message: "Wrong or outdated invitation.",
          duration: 0
        });

        next({ path: to.query.redirect, query: {} })
        return
      }

      if ( error.message === 'wrong-account' ) {

        // TODO: Also go to register when user A clicked on link of user B?

        router.app.$notify.warning({
          title: 'Warning',
          message: "You opened an invitation link that was meant for another user. " +
                   "Please logout and try again.",
          duration: 0
        });

        next({ path: "/", query: {} })
        return
      }
    }
  }

  /* No invitation code, so do nothing */
  next();
})

router.beforeEach(async (to, from, next) => {

  // TODO: Why is this called twice?
  // console.log("[router] route-guard (UserAuth)",
  //   from.path, JSON.stringify(from.query), ">>>",
  //   to.path, JSON.stringify(to.query));
  /*
  if (to.matched.some(record => record.meta.requiresFlexGrid)) {
    store.commit('app/SET_FLEXGRID', true);
  } else {
    store.commit('app/SET_FLEXGRID', false);
  }
  */

  if (to.matched.some(record => record.meta.requiresNoAuth)) {
    next();
  } else {
    /* this route requires auth, check if logged in if not,
       redirect to login page. */
    // if (!store.getters["user/loggedIn"]) {
    if ( await auth_current_user() ) { // TODO: This call should be blocked until user auth is done
      next();
    } else {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    }
  }
});

/*
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresNoAuth)) {
    next();
  } else {
    resourceLoader.onRouteChange( from, to )
    next();
  }
});
*/

/* ----------------------------- Page load indicator ------------------------ */

// See: https://appdividend.com/2018/04/20/vue-router-loading-indicator-tutorial/

NProgress.configure({ showSpinner: false });

router.beforeEach((to, from, next) => {
  // console.log("[router] route-guard (NProgress)", from.path, ">", to.path);
  NProgress.start()
  next()
})

router.afterEach((to, from) => {
  // TODO: Also handle loading / $ready
  NProgress.done();
  NProgress.remove();
})

// console.log("[router] Loading router done:", router);

export default router;
